export const initialState = {
    user: null,
    account: false,
    error : false,
    success : false,
    refAddress : '0x1C629d919EAF6C9671cFA388a616F645Aba06586',
}